export default __webpack_public_path__ + "static/media/ic_avalanche_testnet_96.0ec8b0e8.svg";